<template>
  <div class="language-switcher">
    <button
      type="button"
      class="language-btn"
      :class="{ active: currentLocale === 'en' }"
      @click="changeLanguage('en')"
    >
      EN
    </button>

    <button
      type="button"
      class="language-btn"
      :class="{ active: currentLocale === 'rw' }"
      @click="changeLanguage('rw')"
    >
      RW
    </button>
  </div>
</template>

<script>
export default {
  name: "LanguageSwitcher",

  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },

  methods: {
    changeLanguage(locale) {
      if (!["en", "rw"].includes(locale)) {
        return;
      }

      this.$i18n.locale = locale;

      localStorage.setItem("locale", locale);

      document.documentElement.lang = locale;
    },
  },
};
</script>

<style scoped>
.language-switcher {
  display: inline-flex;
  gap: 5px;
  padding: 4px;
  border: 1px solid rgba(108, 117, 125, 0.25);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
}

.language-btn {
  min-width: 40px;
  padding: 5px 9px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #6c757d;
  font-size: 12px;
  font-weight: 800;
}

.language-btn.active {
  background: #0d6efd;
  color: #fff;
}
</style>